import { render, staticRenderFns } from "./MarketWatch.vue?vue&type=template&id=74ff251f&scoped=true"
import script from "./MarketWatch.vue?vue&type=script&lang=js"
export * from "./MarketWatch.vue?vue&type=script&lang=js"
import style0 from "./MarketWatch.vue?vue&type=style&index=0&id=74ff251f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ff251f",
  null
  
)

export default component.exports